import React from 'react';
import { Link } from 'react-router-dom';

import searchbar from '../scripts/searchbar';
import navbar from '../scripts/navbar';

export default class Header extends React.Component {
  componentDidMount() {
    navbar();
    searchbar();
  }

  onSubmit(e) {
    e.preventDefault();
  }

  render() {
    return (
      <header className="header">
        <div className="top-nav">
          <ul className="top-nav-navbar">
            <li className="top-nav-item">
              <Link to="/">Fender.com</Link>
            </li>
            <li className="top-nav-item">
              <a className="main-nav-item-link not-allowed">Play</a>
            </li>
            <li className="top-nav-item">
              <a className="main-nav-item-link not-allowed">Tune</a>
            </li>
            <li className="top-nav-item">
              <a className="main-nav-item-link not-allowed">Tone</a>
            </li>
          </ul>
        </div>
        <nav className="main-nav">
          <div className="main-nav-logo">
            <Link to="/">
              <i className="fdr-icon fdr-icon--logo" />
            </Link>
          </div>
          <div className="main-nav-collapse collapse" id="navLinks">
            <ul className="main-nav-navbar">
              <li className="main-nav-item">
                <Link to="/electric-guitars" className="main-nav-item-link">
                  Guitars
                  <span className="fdr-icon fdr-icon--arrow" />
                </Link>
              </li>
              <li className="main-nav-item">
                <a className="main-nav-item-link not-allowed">
                  Basses
                  <span className="fdr-icon fdr-icon--arrow" />
                </a>
              </li>
              <li className="main-nav-item">
                <a className="main-nav-item-link not-allowed">
                  Acoustics
                  <span className="fdr-icon fdr-icon--arrow" />
                </a>
              </li>
              <li className="main-nav-item">
                <a className="main-nav-item-link not-allowed">
                  Amps
                  <span className="fdr-icon fdr-icon--arrow" />
                </a>
              </li>
              <li className="main-nav-item">
                <a className="main-nav-item-link not-allowed">
                  Audio
                  <span className="fdr-icon fdr-icon--arrow" />
                </a>
              </li>
              <li className="main-nav-item">
                <a className="main-nav-item-link not-allowed">
                  Effects Pedals
                  <span className="fdr-icon fdr-icon--arrow" />
                </a>
              </li>
              <li className="main-nav-item">
                <a className="main-nav-item-link not-allowed">
                  Accessories
                  <span className="fdr-icon fdr-icon--arrow" />
                </a>
              </li>
              <li className="main-nav-item">
                <a className="main-nav-item-link not-allowed">
                  Lifestyle
                  <span className="fdr-icon fdr-icon--arrow" />
                </a>
              </li>
              <li className="main-nav-item">
                <a className="main-nav-item-link not-allowed">
                  Squier
                  <span className="fdr-icon fdr-icon--arrow" />
                </a>
              </li>
            </ul>
          </div>
          <div className="main-nav-side">
            <div className="main-nav-item">
              <a className="icon">
                <i className="fas fa-map-marker" />
              </a>
            </div>
            <div className="main-nav-item">
              <div className="search-bar">
                <a className="search-icon icon" aria-expanded="false">
                  <i className="fas fa-search" />
                </a>
                <div className="site-search collapse" id="site-search">
                  <form onSubmit={this.onSubmit}>
                    <label className="site-search-title" htmlFor="search">
                      Search
                    </label>
                    <input
                      className="site-search-form"
                      type="search"
                      name="search"
                    />
                    <button
                      className="site-search-button"
                      type="submit"
                      value="Search"
                    >
                      <i className="fas fa-search" />
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <button className="main-nav-toggle" aria-expanded="false">
              <div className="line" />
              <div className="line" />
              <div className="line" />
            </button>
          </div>
        </nav>
      </header>
    );
  }
}
